import * as yup from "yup";

export const PrepaymentValidation = (maxAmount) =>
  yup
    .object()
    .shape({
      prepaid_amount: yup
        .number()
        .nullable()
        .transform((_, val) => (val === "" || val == null ? null : Number(val)))
        .min(0, "Amount cannot be negative")
        .max(maxAmount, `Amount cannot exceed ${maxAmount}`),
    })
    .test(
      "prepayment-required-fields",
      "Prepaid amount, invoice number, and invoice UUID are mandatory when any prepayment field is filled",
      function (values) {
        const prepaidAmount = values?.prepaid_amount;
        const invoiceNumber = values?.invoice_number || "";
        const invoiceUuid = values?.invoice_uuid || "";
        const invoiceDate = values?.invoice_date || null;

        const anyFilled =
          (prepaidAmount != null && !Number.isNaN(Number(prepaidAmount))) ||
          invoiceNumber.length > 0 ||
          invoiceUuid.length > 0 ||
          !!invoiceDate;

        if (!anyFilled) return true;

        const amountOk =
          prepaidAmount != null &&
          !Number.isNaN(Number(prepaidAmount)) &&
          Number(prepaidAmount) > 0;
        const numberOk = invoiceNumber.length > 0;
        const uuidOk = invoiceUuid.length > 0;

        if (!amountOk) {
          return this.createError({
            path: "prepaid_amount",
            message: "Prepaid Amount is required and must be greater than 0",
          });
        }
        if (!numberOk) {
          return this.createError({
            path: "invoice_number",
            message: "Invoice Number is required",
          });
        }
        if (!uuidOk) {
          return this.createError({
            path: "invoice_uuid",
            message: "Invoice UUID is required",
          });
        }

        return true;
      },
    );
